import React from 'react';
import DateUtils from '../../utils/DateUtils';
import {IPost} from '../../types/resources/Post';
import {useTranslation} from 'react-i18next';
import Panel from '../Panel';
import styled from 'styled-components';
import {PostType} from '../../enums/PostType';
import ReactPlayer from 'react-player/lazy';
import {ReactComponent as EyeOffIcon} from '../../icons/eye-off.svg';
import {ReactComponent as PlayIcon} from '../../icons/play-circle.svg';
import {ReactComponent as MusicIcon} from '../../icons/music.svg';
import {LazyLoadImage} from 'react-lazy-load-image-component';

const StyledReactPlayer = styled(ReactPlayer).attrs({
    className: 'cr-aspect-video cr-text-white cr-rounded-block-top',
})`
    width: 100% !important;
    height: auto !important;

    > *, iframe {
        border-top-left-radius: var(--cr-block-rounding);
        border-top-right-radius: var(--cr-block-rounding);
    }
`;

const StyledLazyLoadImage = styled(LazyLoadImage)`
    display: flex !important;

    &:not(.lazy-load-image-loaded) img {
        display: none;
    }
`;

type TProps = {
    post: IPost;
};

const PostCard = ({ post }: TProps) => {
    const { t } = useTranslation();
    const date = DateUtils.getHumanDate(post.createdOn);
    const fullName = [post.authorTitle, post.authorName].join(' ');

    const hasVideo = (post.mediaUrl && (post.type === PostType.MessageWithVideoLink));
    const hasAudio = (post.mediaUrl && (post.type === PostType.MessageWithAudioLink));
    const hasPhoto = (post.mediaUrl && (post.type === PostType.MessageWithPhoto));
    const hasTopMedia = (hasVideo || hasPhoto);

    return (
        <Panel className={'cr-bg-white cr-flex cr-flex-col cr-gap-sm cr-w-100'} padding={false}>
            {!post.isMarkedAsPrivateByAuthor && hasVideo &&
                <StyledReactPlayer
                    url={post.mediaUrl}
                    light={true}
                    playIcon={<PlayIcon />}
                    width={16}
                    height={9}
                />
            }
            {!post.isMarkedAsPrivateByAuthor && hasPhoto &&
                <StyledLazyLoadImage
                    wrapperClassName={'cr-aspect-video cr-w-100 cr-masked cr-rounded-block-top'}
                    className={'cr-aspect-video cr-w-100'}
                    src={post.mediaUrl}
                    effect={'blur'}
                />
            }
            <div className={`cr-p-lg cr-text-primary cr-flex cr-flex-col cr-gap-lg cr-flex-1 ${hasTopMedia ? '' : 'cr-pt-xxl'}`}>
                {!post.isMarkedAsPrivateByAuthor && hasAudio &&
                    <a
                        className='cr-pill cr-bg-alert cr-text-white cr-text-base cr-flex cr-center cr-px-lg'
                        href={post.mediaUrl} target="_blank" rel="noreferrer"
                    >
                        {t('listen-to-music')}
                        <span className={'cr-ml-auto'}>
                            <MusicIcon/>
                        </span>
                    </a>
                }
                <div className={'cr-flex cr-flex-col cr-flex-1 cr-gap-lg cr-relative'}>
                    <div className={'cr-mb-xxl'}>
                        {post.isMarkedAsPrivateByAuthor ? t('post-hidden-message') : post.message}
                        {post.isMarkedAsPrivateByAuthor &&
                            <div className={'cr-text-secondary cr-mt-lg'}>
                                <EyeOffIcon/>
                            </div>
                        }
                    </div>
                    <div className={'cr-mt-auto'}>
                        <div className='cr-bold cr-text-alert cr-pb-sm'>{fullName}</div>
                        <div>{date}</div>
                    </div>
                    {/* TODO: Reactions */}
                    {/*<PostStats post={post}/>*/}
                </div>
            </div>
        </Panel>
    );
}

export default PostCard;
